module.exports = __webpack_public_path__ + "static/media/chevron-right.8dff21d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/chevron-right.svg
// module id = 870
// module chunks = 21